export default __webpack_public_path__ + "static/media/ovary2.52cf82d1.jpg";